function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.0001 64C49.6725 64 63.9988 49.6737 63.9988 32.0013C63.9988 14.329 49.6725 0.00268555 32.0001 0.00268555C14.3277 0.00268555 0.00146484 14.329 0.00146484 32.0013C0.00146484 49.6737 14.3277 64 32.0001 64Z",
  fill: "#F3F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6958 38.1396L26.1443 23.6811H30.1085L27.6601 38.1396H23.6958Z",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.7728 24.0548C40.9872 23.7618 39.7564 23.448 38.2193 23.448C34.3015 23.448 31.5418 25.4095 31.5181 28.2196C31.4963 30.2967 33.4881 31.4553 34.9927 32.1475C36.5357 32.8548 37.0547 33.3086 37.0471 33.9407C37.0375 34.9098 35.8143 35.3529 34.6745 35.3529C33.088 35.3523 32.2447 35.1336 30.9426 34.594L30.4317 34.3636L29.875 37.6003C30.8012 38.0041 32.5139 38.3542 34.2919 38.3719C38.4587 38.371 41.1649 36.4338 41.1953 33.432C41.2104 31.7875 40.1539 30.5359 37.8666 29.5037C36.4807 28.8357 35.6318 28.3895 35.641 27.7115C35.641 27.1108 36.3599 26.4681 37.9116 26.4681C39.208 26.4479 40.1473 26.7289 40.8795 27.0219L41.2342 27.1887L41.7728 24.0548Z",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.5311 23.6811C47.5813 23.6811 46.8951 23.9711 46.4777 24.9125L40.6025 38.1401H44.7998L45.6158 35.9245H50.6305L51.0963 38.1401H54.8277L51.5633 23.6815H48.5312L48.5311 23.6811ZM46.7294 33.0314C47.0568 32.1988 48.3083 28.9903 48.3083 28.9903C48.2856 29.0282 48.6341 28.1536 48.8343 27.6109L49.1026 28.8569C49.1026 28.8569 49.8609 32.3083 50.0201 33.0318H46.7294V33.0314Z",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4667 33.5922L16.1175 31.6101C15.394 29.2995 13.1485 26.7995 10.6323 25.547L14.1348 38.1396H18.333L24.629 23.6811H20.4318L16.4667 33.5922Z",
  fill: "#293688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.32275 23.6811V23.9146C11.2971 25.111 14.7505 28.1355 16.1177 31.6102L14.6803 24.915C14.4404 24 13.7132 23.713 12.8528 23.6812L6.32275 23.6811Z",
  fill: "#F7981D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.998 63.9998C44.3486 63.9998 55.0575 56.9989 60.3915 46.7527H3.60498C8.93944 56.9989 19.6479 63.9998 31.998 63.9998Z",
  fill: "#F7981D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.9979 0C19.8434 0 9.27181 6.77647 3.85498 16.7579H60.1419C54.7244 6.77701 44.1525 0 31.9979 0Z",
  fill: "#293688"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white"
})));
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visaCard.e43e9af2.svg";
export { ForwardRef as ReactComponent };